require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./articles-2015-05-11-scaleft.json") })
        }
      }, "path---articles-2015-05-11-scaleft");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---articles-2015-05-11-scaleft!./.cache/json/articles-2015-05-11-scaleft.json
// module id = 629
// module chunks = 231608221292675